module.exports = __webpack_public_path__ + "img/stripe_mastercard_light.dc337432.png";